import { action } from "../common/Action"
import { CaldaieClient } from "../generated";

const service = new CaldaieClient();

class TipiCaldaieActions {
    @action
    async getAll() {
        return (await service.getTipiCaldaia())!;
    };
}
export default new TipiCaldaieActions();